import React from "react";
import { Route } from "react-router-dom";
import {
  HairFunnelAnalyticsPage,
  HairServiceAnalyticsPage,
  PortalCustomerAnalyticsPage,
  PortalFlowAnalyticsPage,
  PortalStaffAnalyticsPage,
  SkinFunnelAnalyticsPage,
  SkinServiceAnalyticsPage,
} from "./portalAnalyticsPages";

function wrapRoute({ withSuspense, Layout, PermRoute, canView, node }) {
  const inner = withSuspense(node);
  if (PermRoute) {
    return (
      <PermRoute check={canView}>
        <Layout>{inner}</Layout>
      </PermRoute>
    );
  }
  if (typeof canView === "function" && !canView()) {
    return null;
  }
  return <Layout>{inner}</Layout>;
}

/** Skin / hair split pages (workspace + partner). */
export function renderSkinHairAnalyticsRoutes({
  portalId,
  basePath,
  withSuspense,
  Layout,
  PermRoute,
  canViewSkin = () => true,
  canViewHair = () => true,
  hqApi = null,
}) {
  const page = (Component, canView) =>
    wrapRoute({
      withSuspense,
      Layout,
      PermRoute,
      canView,
      node: <Component portalId={portalId} hqApi={hqApi} />,
    });

  return (
    <>
      <Route
        path={`${basePath}/analytics/skin/funnel`}
        element={page(SkinFunnelAnalyticsPage, canViewSkin)}
      />
      <Route
        path={`${basePath}/analytics/skin/services`}
        element={page(SkinServiceAnalyticsPage, canViewSkin)}
      />
      <Route
        path={`${basePath}/analytics/hair/funnel`}
        element={page(HairFunnelAnalyticsPage, canViewHair)}
      />
      <Route
        path={`${basePath}/analytics/hair/services`}
        element={page(HairServiceAnalyticsPage, canViewHair)}
      />
    </>
  );
}

/** HQ workspace analytics pages (partner keeps legacy routes for flow/staff/customer). */
export function renderWorkspaceAnalyticsRoutes({
  withSuspense,
  Layout,
  PermRoute,
  canViewSkin = () => true,
  canViewHair = () => true,
  canViewFlow = () => true,
  canViewGuestOps = () => true,
  hqApi = null,
}) {
  const portalId = "workspace";
  const basePath = "/nyafaz-ep/workspace";
  const page = (Component, canView) =>
    wrapRoute({
      withSuspense,
      Layout,
      PermRoute,
      canView,
      node: <Component portalId={portalId} hqApi={hqApi} />,
    });

  return (
    <>
      <Route
        path={`${basePath}/analytics/skin/funnel`}
        element={page(SkinFunnelAnalyticsPage, canViewSkin)}
      />
      <Route
        path={`${basePath}/analytics/skin/services`}
        element={page(SkinServiceAnalyticsPage, canViewSkin)}
      />
      <Route
        path={`${basePath}/analytics/hair/funnel`}
        element={page(HairFunnelAnalyticsPage, canViewHair)}
      />
      <Route
        path={`${basePath}/analytics/hair/services`}
        element={page(HairServiceAnalyticsPage, canViewHair)}
      />
      <Route
        path={`${basePath}/flow-analytics`}
        element={page(PortalFlowAnalyticsPage, canViewFlow)}
      />
      <Route
        path={`${basePath}/staff-analytics`}
        element={page(PortalStaffAnalyticsPage, canViewGuestOps)}
      />
      <Route
        path={`${basePath}/customer-analytics`}
        element={page(PortalCustomerAnalyticsPage, canViewGuestOps)}
      />
    </>
  );
}

/** Executive HQ analytics (same pages as workspace, executive session). */
export function renderExecutiveAnalyticsRoutes({
  withSuspense,
  Layout,
  PermRoute,
  canViewSkin = () => true,
  canViewHair = () => true,
  canViewFlow = () => true,
  canViewGuestOps = () => true,
  hqApi = null,
}) {
  const portalId = "executive";
  const basePath = "/nyafaz-ep/executive";
  const page = (Component, canView) =>
    wrapRoute({
      withSuspense,
      Layout,
      PermRoute,
      canView,
      node: <Component portalId={portalId} hqApi={hqApi} />,
    });

  return (
    <>
      <Route
        path={`${basePath}/analytics/skin/funnel`}
        element={page(SkinFunnelAnalyticsPage, canViewSkin)}
      />
      <Route
        path={`${basePath}/analytics/skin/services`}
        element={page(SkinServiceAnalyticsPage, canViewSkin)}
      />
      <Route
        path={`${basePath}/analytics/hair/funnel`}
        element={page(HairFunnelAnalyticsPage, canViewHair)}
      />
      <Route
        path={`${basePath}/analytics/hair/services`}
        element={page(HairServiceAnalyticsPage, canViewHair)}
      />
      <Route
        path={`${basePath}/flow-analytics`}
        element={page(PortalFlowAnalyticsPage, canViewFlow)}
      />
      <Route
        path={`${basePath}/staff-analytics`}
        element={page(PortalStaffAnalyticsPage, canViewGuestOps)}
      />
      <Route
        path={`${basePath}/customer-analytics`}
        element={page(PortalCustomerAnalyticsPage, canViewGuestOps)}
      />
    </>
  );
}
